// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 0 1rem 1rem 0;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.sidebar .content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.sidebar .avatarContainer {
  margin-top: 0.5rem;
  position: relative;
}
.sidebar .avatarContainer .camera {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem;
  width: 26px;
  height: 26px;
  border-radius: 13px;
  position: absolute;
  left: -4px;
  bottom: 0;
  cursor: pointer;
}
.sidebar .avatarContainer .remove {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem;
  width: 22px;
  height: 22px;
  border-radius: 13px;
  position: absolute;
  right: -4px;
  top: 0;
  z-index: 99;
  cursor: pointer;
}
.sidebar .badge {
  border-radius: 0.75rem;
  padding: 0.4rem 0.8rem;
  font-size: 0.6rem;
}
.sidebar .title {
  font-weight: bold;
  font-size: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/SideBar/sidebar.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AACF;AAEE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAAJ;AAGE;EACE,kBAAA;EACA,kBAAA;AADJ;AAGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AADN;AAII;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;AAFN;AAME;EACE,sBAAA;EACA,sBAAA;EACA,iBAAA;AAJJ;AAOE;EACE,iBAAA;EACA,iBAAA;AALJ","sourcesContent":[".sidebar {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  padding: 0 1rem 1rem 0;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n\n\n  .content {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .avatarContainer {\n    margin-top: 0.5rem;\n    position: relative;\n\n    .camera {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0.2rem ;\n      width: 26px;\n      height: 26px;\n      border-radius: 13px;\n      position: absolute;\n      left: -4px;\n      bottom: 0;\n      cursor: pointer;\n    }\n\n    .remove {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0.2rem ;\n      width: 22px;\n      height: 22px;\n      border-radius: 13px;\n      position: absolute;\n      right: -4px;\n      top: 0;\n      z-index: 99;\n      cursor: pointer;\n    }\n  }\n\n  .badge {\n    border-radius: 0.75rem;\n    padding: 0.4rem 0.8rem;\n    font-size: 0.6rem;\n  }\n\n  .title {\n    font-weight: bold;\n    font-size: 1.5rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
